import { apiClient } from '../../gateways/api'
import type { Projectdossier } from '../types/Projectdossier'

export { fetchProjectdossier }

const fetchProjectdossier = async ({
  id,
}: {
  id: string
}): Promise<Projectdossier> => {
  const { data } = await apiClient({
    url: `/rest/projectdossier/${id}`,
    method: 'GET',
  })

  return data
}
